import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "typeField",
  standalone: false,
})
export class TypeFieldPipe implements PipeTransform {
  transform(key: string, fieldGroups: any, groupType: string): string {
    let typeField = "keyword";
    const [filterStructuredGroup] = fieldGroups.filter(
      (item) => item.group_type === groupType,
    );
    const { fields } = filterStructuredGroup;

    fields.forEach((fieldMap) => {
      if (fieldMap.name === key) {
        typeField = fieldMap.type;
      }
    });
    return typeField;
  }
}
